// Marketo REST API documentation:
// https://developer.adobe.com/marketo-apis/

// The Marketo API is unable to be used by browsers directly due to CORS issues.
// We proxy the request through the WordPress backend to avoid CORS issues.
export const marketoApiBaseUrl = `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/triumph/api/marketo`;
